<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-container>
      <v-card class="mx-auto" height="300px">
        <v-subheader>{{ $t('DASHBOARD.MAP') }}</v-subheader>
        <v-card
          class="d-flex flex-column justify-center align-center ma-3"
          flat
          tile
        >
          <v-img
            v-if="showImg"
            :src="url"
            contain
            max-width="150"
            max-height="150"
            @error="changeShowImg"
          />
          <v-icon v-else x-large>mdi-map</v-icon>
        </v-card>
      </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: 'DashboardMapCard',

  props: {
    url: {
      type: String,
      default: process.env.VUE_APP_CORE + '/images/swiss-map.jpg'
    }
  },

  data: () => ({
    showImg: true
  }),

  methods: {
    changeShowImg() {
      this.showImg = !this.showImg;
    }
  }
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
